  <ion-item
    lines="none"
    tooltip
    [ngClass]="{
      'vertical': mode === 'vertical',
      'medium-horizontal': mode === 'medium-horizontal',
      'large-horizontal': mode === 'large-horizontal'
    }"
    tooltipMode="click"
    [tooltipTemplate]="userCard"
    [tooltipPosition]="userCardPosition">
    <ion-avatar slot="start">
      <img [src]="user?.photoURL || '/assets/images/svg/icons/avatar.svg'"/>
    </ion-avatar>
    <mat-icon [ngClass]="{ 'customCssForLandPage': customCss }">arrow_drop_down</mat-icon>
    <ion-label
      class="body-3 text-bold"
      [ngClass]="{
        'customCssForLandPage': customCss,
      }">
      {{ user?.email | apply : ShortName : user?.displayName }}
    </ion-label>
  </ion-item>
  <ion-item
    *ngIf="mode === 'vertical'"
    class=" text-grey-500 text-uppercase w-80"
    lines="none">
    <mat-icon class='mr-2'>logout</mat-icon>
    <button
      *ngIf="mode === 'vertical'"
      class="fx-center fx-align-center px-2  mb-2 text-center body-2 text-grey-500 mt-2 text-uppercase bg-white"
      mat-button
      (click)="logout.emit()">
      logout
    </button>
  </ion-item>

  <ng-template #userCard>
    <!-- user firebase card & logout -->
    <div
      *ngIf="mode === 'medium-horizontal' || mode === 'large-horizontal'"
      class="fx-col fx-align-center text-grey-400 bg-grey-100 p-3 border-box radius-8 border-1 border-grey-100">
      <div class="s-15 overflow-hidden rounded">
        <img
          class="s-15 rounded"
          [src]="user?.photoURL || '/assets/images/svg/icons/avatar.svg'"/>
      </div>
      <div class="text-style-italic text-400 ellipsed mt-2 body-2">
        {{ user?.email }}
      </div>
      <button
        class="px-2 text-center mt-2 text-uppercase bg-white"
        mat-button
        (click)="logout.emit()">
        logout
      </button>
    </div>
  </ng-template>
